module.exports = __webpack_public_path__ + "static/media/logo_PNG.44dc02b8.png";